export default "__VITE_ASSET__94Ao7I44__"